var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20V2.22222C0 1.61111 0.224 1.08778 0.672 0.652224C1.12 0.216668 1.6579 -0.000738854 2.28571 1.88644e-06H13.7143C14.3429 1.88644e-06 14.8811 0.21778 15.3291 0.653335C15.7771 1.08889 16.0008 1.61185 16 2.22222V20L8 16.6667L0 20ZM2.28571 16.6111L8 14.2222L13.7143 16.6111V2.22222H2.28571V16.6111Z",
    fill: "#AD2F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.da3884b82bcc5cbbad1cac60f2b67ee8.svg";
export { ForwardRef as ReactComponent };